import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        VCol,
        { attrs: { name: "pagination-catalog" } },
        [
          _c(VPagination, {
            attrs: {
              length: _vm.pagination.tokens
                ? Object.keys(_vm.pagination.tokens).length + 1
                : 0,
              circle: "",
              "total-visible": 5,
            },
            on: { input: _vm.goInput },
            model: {
              value: _vm.pagination.current,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "current", $$v)
              },
              expression: "pagination.current",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }